import { Link } from "react-router-dom";
import type { SpecialItem } from "@/types/content";

type SpecialCardProps = {
  special: SpecialItem;
};

export default function SpecialCard({ special }: SpecialCardProps) {
  return (
    <Link
      to={`/special/${special.id}`}
      className="group relative block cursor-pointer overflow-hidden rounded-lg border border-primary-800"
      aria-label={`进入专题${special.title}`}
    >
      <div className="aspect-[16/10] w-full overflow-hidden bg-primary-900">
        <img
          src={special.cover}
          alt={`${special.title}专题主图`}
          title={`${special.title} - 天马传媒影视专题`}
          className="h-full w-full object-cover object-top transition duration-700 group-hover:scale-[1.05]"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/40 to-transparent"></div>
      <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
        <p className="text-[11px] tracking-[0.2em] text-accent-300">
          专题 · {special.tags[0]}
        </p>
        <h3 className="mt-1.5 font-heading text-lg font-semibold text-background-50 md:text-xl">
          {special.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-background-300">{special.subtitle}</p>
        <span className="mt-3 inline-flex items-center gap-1 text-xs text-background-100 transition group-hover:text-accent-300">
          进入专题
          <i className="ri-arrow-right-line transition group-hover:translate-x-1"></i>
        </span>
      </div>
    </Link>
  );
}